import React, {  useState } from 'react'
import PropTypes from 'prop-types'
import classes from './index.module.css'
import { useSearchArtists } from '../../../hooks/useSearchArtists'
import { useGetArtists } from '../../../hooks/useGetArtists'
import CreateOrganizationSortedArtistsList from '../../CreateOrganizationSortedArtistsList'
import CreateOrganizationPopupArtistsCount from '../../CreateOrganizationPopupArtistsCount'
import CreateOrganizationPopupArtistsSearch from '../../CreateOrganizationPopupArtistsSearch'
import usePopup from '../../../hooks/usePopup'

function debounce(func, delay) {
  let timeoutId
  return function (...args) {
    if (timeoutId) {
      clearTimeout(timeoutId)
    }
    timeoutId = setTimeout(() => {
      func.apply(this, args)
    }, delay)
  }
}
export default function CreateOrganizationPopupFormStep2({
  setStepData,
  stepData,
}) {
  const [searchString, setSearchString] = useState('')

  const {
    openPopup: showOptions,
    closePopup: hideOptions,
    isOpen: isOptionsOpen,
  } = usePopup()

  const handleSetSearchString = debounce(
    e => setSearchString(e.target.value),
    500
  )

  const handleRemoveAllArtists = () => {
    setStepData([])
  }

  const handleAddArtists = artists => {
    const newArtists = Array.isArray(artists) ? artists : [artists]
    setStepData(prev => [
      ...new Map(
        [...prev, ...newArtists].map(item => [item.f_id, item])
      ).values(),
    ])
  }
  const handleRemoveArtist = artist => {
    setStepData(prev => prev.filter(item => item.f_id !== artist.f_id))
  }

  const {
    data: artistsList,
    isLoading: isArtistsListLoading,
    fetchNextPage: fetchNextArtists,
    hasNextPage: hasNextPageArtists,
    isFetchingNextPage: isFetchingNextPageArtists,
  } = useGetArtists()

  const {
    data: artistsSearchList,
    isLoading: isArtistsSearchListLoading,
    fetchNextPage: fetchNextSearchArtists,
    hasNextPage: hasNextPageSearchArtists,
    isFetchingNextPage: isFetchingNextPageSearchArtists,
  } = useSearchArtists(searchString.trim())

  const artists = searchString
    ? artistsSearchList?.pages.map(page => page.artists).flat()
    : artistsList?.pages.map(page => page.artists).flat()
  const fetchNextPage = searchString ? fetchNextSearchArtists : fetchNextArtists
  const hasNextPage = searchString
    ? hasNextPageSearchArtists
    : hasNextPageArtists

  const isFetchingNextPage = searchString
    ? isFetchingNextPageSearchArtists
    : isFetchingNextPageArtists

  const isLoading = searchString
    ? isArtistsSearchListLoading
    : isArtistsListLoading

  return (
    <div className={classes.wrapper}>
      <div className={classes.search}>
        <CreateOrganizationPopupArtistsSearch
          handleSetSearchString={handleSetSearchString}
          artists={artists}
          fetchNextPage={fetchNextPage}
          hasNextPage={hasNextPage}
          isFetchingNextPage={isFetchingNextPage}
          isLoading={isLoading}
          handleAddArtists={handleAddArtists}
          handleRemoveArtist={handleRemoveArtist}
          stepData={stepData}
          showOptions={showOptions}
          hideOptions={hideOptions}
          isOptionsOpen={isOptionsOpen}
        />
      </div>

      <div className={classes.count}>
        <CreateOrganizationPopupArtistsCount
          count={stepData.length}
          action={handleRemoveAllArtists}
        />
      </div>
      <div className={classes.sorted}>
        <CreateOrganizationSortedArtistsList
          artists={stepData}
          handleRemoveArtist={handleRemoveArtist}
        />
      </div>
    </div>
  )
}

CreateOrganizationPopupFormStep2.propTypes = {
  setStepData: PropTypes.func,
  stepData: PropTypes.array,
}
